var childrenList = new Array();
// 系统登录页面路由
import common from '../view/common/_router'
pushArray(childrenList, common.index)

//系统配置路由
import sys from '../view/sys/_router'
pushArray(childrenList, sys.index)

//deepseekAI路由
import deepseek from '../view/deepseek/_router'
pushArray(childrenList, deepseek.index)

//商品
import commodity from '../view/commodity/_router'
pushArray(childrenList, commodity.index)

//门店
import cstorehome from '../view/cstorehome/_router'
pushArray(childrenList, cstorehome.index)

//商品分类
import commoditytype from '../view/commoditytype/_router'
pushArray(childrenList, commoditytype.index)

//商品品牌
import commoditypp from '../view/commoditypp/_router'
pushArray(childrenList, commoditypp.index)

//会员
import vip from '../view/vip/_router'
pushArray(childrenList, vip.index)

//服务商品信息
import fwcommodity from '../view/fwcommodity/_router'
pushArray(childrenList, fwcommodity.index)

//优惠卷
import pt_yhq from '../view/pt_yhq/_router'
pushArray(childrenList, pt_yhq.index)

//新人礼
import pt_srl from '../view/pt_srl/_router'
pushArray(childrenList, pt_srl.index)

//仓库信息
import warehouse from '../view/warehouse/_router'
pushArray(childrenList, warehouse.index)

//订单信息
import order from '../view/order/_router'
pushArray(childrenList, order.index)

//订单详细信息
import orderdis from '../view/orderdis/_router'
pushArray(childrenList, orderdis.index)

//服务分类
import fuwutype from '../view/fuwutype/_router'
pushArray(childrenList, fuwutype.index)

//二维码收款记录
import tearecharge from '../view/tearecharge/_router'
pushArray(childrenList, tearecharge.index)

//餐饮商品
import footcommodity from '../view/footcommodity/_router'
pushArray(childrenList, footcommodity.index)

import yh_order from '../view/yh_order/_router'
pushArray(childrenList, yh_order.index)

import cwcommodity from '../view/cwcommodity/_router'
pushArray(childrenList, cwcommodity.index)

import fwsptype from '../view/fwsptype/_router'
pushArray(childrenList, fwsptype.index)

import dpywyuser from '../view/dpywyuser/_router'
pushArray(childrenList, dpywyuser.index)

import dp_yjhd from '../view/dp_yjhd/_router'
pushArray(childrenList, dp_yjhd.index)

import dp_yjhdplan from '../view/dp_yjhdplan/_router'
pushArray(childrenList, dp_yjhdplan.index)

import tea_user from '../view/tea_user/_router'
pushArray(childrenList, tea_user.index)

 export default {
    index: childrenList
}
function pushArray(obj1, obj2) {
    obj2.forEach(function (o) {
        obj1.push(o);
    })
}



// WEBPACK FOOTER //
// ./src/view/_router.js